/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_To_Title_CaseInputs */



/**
* | output |
* | --- |
* | "Text to Title Case" |
*
* @param {Text_To_Title_CaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const text_to_title_case = /** @type {((inputs?: Text_To_Title_CaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_To_Title_CaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte en casse de titre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text in Titelformatierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo in maiuscolo/minuscolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текст с регистром заголовка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto a título en mayúsculas y minúsculas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本转换为标题大小写")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストをタイトル大文字にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट को टाइटल केस में बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto para título em caixa alta/baixa")
	return /** @type {LocalizedString} */ ("Text to Title Case")
});